module.exports = __webpack_public_path__ + "el_GR-header-e7b64b.webp";